import React from 'react';
import { observer } from 'mobx-react-lite';
import { RouteConfig } from 'routes/index';
import { brokerOrEmployerRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useRootStore } from 'store/rootStore';
import { Switch } from 'react-router-dom';
import RoleBasedRoute from 'routes/RoleBasedRoute';
import GenerateProposalPage from 'pages/proposal-generation/GenerateProposalPage';
import ProposalReadyPage from './ProposalReadyPage';
import ChooseTheWayPage from './ChooseTheWayPage';

const routes: RouteConfig[] = [
  { path: '/generate-proposal/choose-the-way/:periodId', component: ChooseTheWayPage },
  { path: '/generate-proposal/ready/:periodId', component: ProposalReadyPage, roleCheck: brokerOrEmployerRights },
  {
    path: '/generate-proposal/:periodId',
    component: GenerateProposalPage,
    roleCheck: brokerOrEmployerRights,
  },
];

const LocalRouter: React.FC = observer(() => {
  const {
    userStore: { userRoles },
  } = useRootStore();

  const convertedUserRoles = userRoles.slice();
  return (
    <Switch>
      {routes.map((route) => (
        <RoleBasedRoute exact key={route.path} userRoles={convertedUserRoles} {...route} />
      ))}
    </Switch>
  );
});

export const ProposalGenerationFlow: React.FC = () => {
  return <LocalRouter />;
};
